import { useEffect, useState } from 'react'
import { Container, Paper, Title, Text, Loader, Button, Stack, ThemeIcon } from '@mantine/core'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { CheckCircle, XCircle } from 'lucide-react'
import api from '../../api/client'

export function VerifyUser() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('')

  useEffect(() => {
    const token = searchParams.get('token')
    if (!token) {
      setStatus('error')
      setMessage('Invalid verification request')
      return
    }
    api.get(`/auth/verify-user?token=${encodeURIComponent(token)}`)
      .then(() => {
        setStatus('success')
        setMessage('Your email has been verified! You can now sign in.')
      })
      .catch((err) => {
        setStatus('error')
        setMessage(err.response?.data?.detail || 'Invalid verification request')
      })
  }, [searchParams])

  return (
    <Container size={420} my={80}>
      <Paper withBorder shadow="md" p={40} radius="md" bg="var(--sat-bg)">
        <Stack align="center" gap="md">
          {status === 'loading' && (
            <>
              <Loader size="lg" color="grapefruit" />
              <Text c="dimmed">Verifying your email...</Text>
            </>
          )}
          {status === 'success' && (
            <>
              <ThemeIcon size={60} radius="xl" color="teal" variant="light">
                <CheckCircle size={32} />
              </ThemeIcon>
              <Title order={2} ta="center" style={{ color: 'var(--sat-text)' }}>Email Verified!</Title>
              <Text ta="center" c="dimmed">{message}</Text>
              <Button fullWidth color="grapefruit" onClick={() => navigate('/login')}>
                Sign In
              </Button>
            </>
          )}
          {status === 'error' && (
            <>
              <ThemeIcon size={60} radius="xl" color="red" variant="light">
                <XCircle size={32} />
              </ThemeIcon>
              <Title order={2} ta="center" style={{ color: 'var(--sat-text)' }}>Verification Failed</Title>
              <Text ta="center" c="dimmed">{message}</Text>
              <Button fullWidth variant="outline" color="grapefruit" onClick={() => navigate('/login')}>
                Back to Login
              </Button>
            </>
          )}
        </Stack>
      </Paper>
    </Container>
  )
}
